import { render } from "./DateRangePicker.html?vue&type=template&id=2a43a2fe"
import script from "./DateRangePicker.ts?vue&type=script&lang=ts"
export * from "./DateRangePicker.ts?vue&type=script&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script